var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 261,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.5 261c72.073 0 130.5-58.427 130.5-130.5C261 58.427 202.573 0 130.5 0 58.427 0 0 58.427 0 130.5 0 202.573 58.427 261 130.5 261zM104.004 84.43c3.823-3.823 10.019-3.823 13.841 0l39.15 39.15a9.784 9.784 0 010 13.84l-39.15 39.15c-3.822 3.823-10.018 3.823-13.841 0-3.822-3.822-3.822-10.018 0-13.84l32.229-32.23-32.229-32.23c-3.822-3.821-3.822-10.019 0-13.84z",
    fill: "url(#paint0_linear_1057_1945)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1057_1945",
    x1: 130.5,
    y1: 0,
    x2: 130.5,
    y2: 261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomArrowRight);
export default __webpack_public_path__ + "static/media/custom-arrow-right.081fcb33b8b87835974712a5fc17b5f4.svg";
export { ForwardRef as ReactComponent };